// Central category constants for the storefront + admin.
//
// DB values (`value`) stay stable so existing products keep matching without
// migration. UI labels can be tweaked freely.  `homeLabel` overrides the label
// used on the homepage's "Shop by Category" cards ("Beauty Essentials" reads
// nicer than "Essentials" in that context).  `defaultImage` is the fallback
// used when the admin hasn't yet uploaded a card image for that category.

export const CATEGORIES = [
  { value: "All",         label: "All",             homeLabel: null,                 slug: "all" },
  { value: "Luxury Wigs", label: "Luxury Wigs",     homeLabel: "Luxury Wigs",        slug: "luxury-wigs" },
  { value: "Braided Wig", label: "Braided Wigs",    homeLabel: "Braided Wigs",       slug: "braided-wigs" },
  { value: "Extensions",  label: "Hair Extensions", homeLabel: "Hair Extensions",    slug: "hair-extensions" },
  { value: "Hair Care",   label: "Hair Care",       homeLabel: "Hair Care",          slug: "hair-care" },
  { value: "Hair Tools",  label: "Hair Tools",      homeLabel: "Hair Tools",         slug: "hair-tools" },
  { value: "Essentials",  label: "Essentials",      homeLabel: "Beauty Essentials",  slug: "essentials" },
];

// Categories rendered on the homepage "Shop by Category" strip (no "All").
export const HOME_CATEGORIES = CATEGORIES.filter((c) => c.value !== "All");

// Fires the currently-selected category into `Collections.jsx` from anywhere
// on the page (e.g. the homepage "Shop by Category" cards).  Also smooth-
// scrolls to the collections section.
export function selectCategoryAndScroll(categoryValue) {
  try {
    window.dispatchEvent(new CustomEvent("demj:select-category", { detail: categoryValue }));
  } catch { /* noop */ }
  const el = document.getElementById("collections");
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

// Resolves the admin-uploaded card image for a category, falling back to the
// category's first product image (best-available), then null.  `products` is
// the collections list (may be undefined during initial load).
export function resolveCategoryCardImage(categoryValue, cardImages = {}, products = []) {
  const slug = CATEGORIES.find((c) => c.value === categoryValue)?.slug;
  if (slug && cardImages && cardImages[slug]) return cardImages[slug];
  if (categoryValue === "All") {
    const first = (products || []).find((p) => p.image);
    return first?.image || null;
  }
  const first = (products || []).find(
    (p) => (p.category || "Luxury Wigs") === categoryValue && p.image
  );
  return first?.image || null;
}
